import { createSlice } from "@reduxjs/toolkit";
import { fetchAppInfo } from "../Actions";

const APP_INFO_SLICE_NAME = "appinfo";

const appInfoInitialState = {
  appInfoResponse: {},
  isLoading: false,
};

const appInfoSlice = createSlice({
  name: APP_INFO_SLICE_NAME,
  initialState: appInfoInitialState,
  reducers: {},
  extraReducers: (builder) => {
    //@ts-ignore
    builder
      .addCase(fetchAppInfo.pending, (state) => {
        state.isLoading = true;
        state.appInfoResponse = {};
        return state;
      })
      .addCase(fetchAppInfo.fulfilled, (state, action) => {
        state.isLoading = false;
        state.appInfoResponse = action.payload;
        return state;
      })
      .addCase(fetchAppInfo.rejected, (state) => {
        state.isLoading = false;
        state.appInfoResponse = {};
      });
  },
});

export const {} = appInfoSlice.actions;
export const appInfoReducer = appInfoSlice.reducer;
